module.exports = __webpack_public_path__ + "img/pdf.6f43d1b1.png";